"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function parseIntSafe(numberString, placeholder = 0) {
    const parsedValue = parseInt(numberString, 10);
    if (!parsedValue) {
        return placeholder;
    }
    return parsedValue;
}
exports.parseIntSafe = parseIntSafe;
//# sourceMappingURL=parseIntSafe.js.map